module.exports = __webpack_public_path__ + "static/media/MSMEBen6.84ea4270.svg";